import { render } from "./nft-landing.vue?vue&type=template&id=435d4fc5"
import script from "./nft-landing.vue?vue&type=script&lang=js"
export * from "./nft-landing.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__